import React from "react";
import { Box, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";

/**
 * Search input component for filtering users
 */
const UserSearchInput = ({ value, onChange, label = "Search Users" }) => {
  const handleClear = () => {
    onChange({ target: { value: "" } });
  };

  return (
    <Box sx={{ minWidth: "280px" }}>
      <Typography
        variant="caption"
        sx={{
          color: "#888",
          fontSize: "0.75rem",
          fontWeight: 600,
          textTransform: "uppercase",
          letterSpacing: "0.8px",
          display: "block",
          marginBottom: "10px",
        }}
      >
        {label}
      </Typography>
      <TextField
        size="small"
        placeholder="Search by name or email..."
        value={value}
        onChange={onChange}
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" sx={{ color: "#999" }} />
            </InputAdornment>
          ),
          endAdornment: value && (
            <InputAdornment position="end">
              <IconButton size="small" onClick={handleClear} edge="end">
                <CloseIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        }}
        sx={{
          backgroundColor: "#fff",
          "& .MuiOutlinedInput-root": {
            height: "40px",
            borderRadius: "8px",
            fontSize: "0.875rem",
            "& fieldset": {
              borderColor: "#e0e0e0",
            },
            "&:hover fieldset": {
              borderColor: "#bdbdbd",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#1565c0",
            },
          },
        }}
      />
    </Box>
  );
};

export default UserSearchInput;
